import { LogRelatoryInteractor } from "../../Coordinator/LogRelatory/LogRelatoryInteractor";

export class LogRelatoryViewModel {

    private interactor: LogRelatoryInteractor
    constructor() {
        this.interactor = new LogRelatoryInteractor()
    }

    public fetchLogs(filters: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchLogs(filters).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            })
        })
    }

    public fetchLogsRelatory(filters: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchLogsRelatory(filters).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            })
        })
    }
}